import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function SolucionSection() {
  return <section className="bg-[#FFFFFF] py-24 md:py-32 px-6 md:px-12 lg:px-24 border-y border-[#0F0F0F]/5" data-id="element-116">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center space-y-12" data-id="element-117">
        <div className="space-y-6" data-id="element-118">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0F0F0F]" data-id="element-119">
            Juega Desde Otro Nivel
          </h2>
          <p className="text-xl md:text-2xl text-[#0F0F0F] max-w-2xl mx-auto leading-relaxed" data-id="element-120">
            Intervención estratégica de 90 minutos
            <br data-id="element-121" />
            para rediseñar tu agenda alrededor del 20% que genera crecimiento.
          </p>
        </div>

        <div className="bg-[#0F0F0F] text-[#FFFFFF] p-8 md:p-12 rounded-3xl w-full text-left max-w-2xl mx-auto shadow-2xl" data-id="element-122">
          <ul className="space-y-6" data-id="element-123">
            <li className="flex items-start" data-id="element-124">
              <CheckCircle2 className="w-8 h-8 text-[#C9A96E] mr-4 flex-shrink-0" data-id="element-125" />
              <span className="text-xl md:text-2xl" data-id="element-126">
                Detectar fugas de tiempo, energía y foco
              </span>
            </li>
            <li className="flex items-start" data-id="element-127">
              <CheckCircle2 className="w-8 h-8 text-[#C9A96E] mr-4 flex-shrink-0" data-id="element-128" />
              <span className="text-xl md:text-2xl" data-id="element-129">
                Identificar tu 20% crítico
              </span>
            </li>
            <li className="flex items-start" data-id="element-130">
              <CheckCircle2 className="w-8 h-8 text-[#C9A96E] mr-4 flex-shrink-0" data-id="element-131" />
              <span className="text-xl md:text-2xl" data-id="element-132">Reordenar tu agenda</span>
            </li>
          </ul>
        </div>

        <div className="space-y-8 pt-4" data-id="element-133">
          <p className="text-xl md:text-2xl font-semibold text-[#0F0F0F]" data-id="element-134">
            En 90 minutos descubrirás qué trabajo en tu agenda no debería
            existir.
          </p>

          <button className="bg-[#C9A96E] text-[#0F0F0F] font-bold text-lg md:text-xl py-4 px-10 rounded-full hover:opacity-90 transition-opacity w-full md:w-auto shadow-xl" data-id="element-135">
            DESCUBRIR MI 20% CRÍTICO
          </button>
        </div>
      </div>
    </section>;
}